export const HubspotObjectTypes = {
  contact: 'CONTACT',
  deal: 'DEAL',
  ticket: 'TICKET',
};
